/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import { SortDirection } from '../components/Table/types';
import { SEARCH_WINE_MATRIX } from '../graphql/queries/searchWineMatrix';
import { WineMatrix, WineMatrixData } from '../__generated__/graphql';

import { ServerSideFilterConfigType } from '../components/Filters/serversFilter';
import { getfilters } from '../views/Discover/components/ActiveMarkets/helper';

interface UseActiveMarketAssetProps {
  from: number;
  pageSize: number;
  tab: keyof WineMatrixData;
  sortBy?: keyof WineMatrixData;
  sortDirection?: SortDirection;
  wineName?: string;
  isLoggedIn?: boolean;
  filterConfig?: ServerSideFilterConfigType;
}

export function useWineMatrix({
  from,
  tab,
  isLoggedIn = false,
  filterConfig,
  sortBy,
  pageSize,
  sortDirection,
}: UseActiveMarketAssetProps) {
  const filters = getfilters(filterConfig);
  const [results, setResults] = useState<WineMatrix[]>([]);
  const [isError, setError] = useState<string | null>(null);

  const { data, loading, error, fetchMore } = useQuery(SEARCH_WINE_MATRIX, {
    variables: {
      from: from,
      pageSize,
      tab,
      filters: filters,
      sortFilter: sortBy,
      sortOrder: sortDirection,
    },
    ...(isLoggedIn ? { fetchPolicy: 'network-only' } : { context: { serviceName: 'insecure' } }),
  });

  const total = data?.searchWineMatrix?.total ?? 0;

  const getMoreResults = async (fromIn: number, pageSizeIn: number) => {
    try {
      const _results = await fetchMore({
        variables: {
          from: fromIn,
          pageSize: pageSizeIn,
        },
      });
      const wineMatrixData = _results.data.searchWineMatrix.results as WineMatrix[];
      if (!wineMatrixData) return [];
      return wineMatrixData;
    } catch (_error) {
      console.log('_error ', _error);
      setError('error occurred');
      return [];
    }
  };

  useEffect(() => {
    if (!data) return;
    const wineMatrixData = data.searchWineMatrix.results as WineMatrix[];

    setResults(wineMatrixData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, loading]);

  return {
    results,
    total,
    loading,
    error: error || isError,
    getMoreResults,
  };
}
